import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { routes } from './app.routes';
import { provideClientHydration } from '@angular/platform-browser';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { BrandGateway } from '@domain/models/brand/gateway/brand.gateway';
import { BrandService } from '@infraestructure/drive-adapter/brand-service/brand.service';
import { AccountSettingsGateway } from '@domain/models/account-settings/gateway/account-settings.gateway';
import { AccountSettingsService } from '@infraestructure/drive-adapter/account-settings/account-settings.service';
import { JwtModule } from '@auth0/angular-jwt';
import { authInterceptor } from '@infraestructure/helpers/auth/auth.interceptor';
import { featureFlagBypassInterceptor } from '@infraestructure/helpers/feature-flags/feature-flag-bypass.interceptor';
import { MXGateway } from '@domain/models/mx/gateway/mx.gateway';
import { MXService } from '@infraestructure/drive-adapter/mx/mx.service';
import { ProductGateway } from '@domain/models/product/gateway/product.gateway';
import { ProductService } from '@infraestructure/drive-adapter/product/product.service';
import { RewardsProgramGateway } from '@domain/models/reward/gateway/rewards-program.gateway';
import { RewardsProgramService } from '@infraestructure/drive-adapter/reward-service/rewards-program.service';
import { CrossSellGateway } from '@domain/models/cross-sell/gateway/cross-sell.gateway';
import { CrossSellService } from '@infraestructure/drive-adapter/cross-sell-service/cross-sell.service';
import { OnboardingGateway } from '@domain/models/onboarding/gateway/onboarding.gateway';
import { OnboardingService } from '@infraestructure/drive-adapter/onboarding/onboarding.service';
import { FeatureFlagsGateway } from '@domain/models/feature-flags/gateway/feature-flags.gateway';
import { FeatureFlagsService } from '@infraestructure/drive-adapter/feature-flags/feature-flags.service';
import { AnalyticsGateway } from '@domain/models/analytics/gateway/analytics.gateway';
import { Ga4AnalyticsService } from '@infraestructure/drive-adapter/analytics/ga4-analytics.service';
import { provideAnalyticsPageViews } from '@infraestructure/helpers/analytics/analytics-page-view.initializer';
import { CreditScoreArrayGateway } from '@domain/models/credit-score-array/gateway/credit-score-array.gateway';
import { CreditScoreArrayService } from '@infraestructure/drive-adapter/credit-score-array/credit-score-array.service';
import { memberTokenInterceptor } from '@infraestructure/helpers/auth/member-token.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    // Each route opens at the top so GA4 scroll depth is measured per page
    provideRouter(routes, withInMemoryScrolling({ scrollPositionRestoration: 'top' })),
    provideClientHydration(),
    provideHttpClient(withFetch()),
    provideHttpClient(withInterceptors([featureFlagBypassInterceptor, authInterceptor, memberTokenInterceptor])),
    { provide: BrandGateway, useClass: BrandService },
    { provide: AccountSettingsGateway, useClass: AccountSettingsService },
    { provide: MXGateway, useClass: MXService },
    { provide: ProductGateway, useClass: ProductService },
    { provide: RewardsProgramGateway, useClass: RewardsProgramService },
    { provide: CrossSellGateway, useClass: CrossSellService },
    { provide: OnboardingGateway, useClass: OnboardingService },
    { provide: FeatureFlagsGateway, useClass: FeatureFlagsService },
    { provide: AnalyticsGateway, useExisting: Ga4AnalyticsService },
    provideAnalyticsPageViews(),
    { provide: CreditScoreArrayGateway, useClass: CreditScoreArrayService },
    importProvidersFrom([
      // ...
      JwtModule.forRoot({
        config: {
          tokenGetter: () => localStorage.getItem('auth-token'),
        },
      }),
    ]),
  ],
};
 